<template>
    <div>
        <div class="prescription-section">
            <div class="row ">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card-body bg-white border-radius-5 p-0 h-100">
                            <div class="d-flex justify-content-between">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item pl-0"><a class="nav-link" href="#" @click.prevent="tab ='Current'" :class="(tab =='Current')?'active':''">Current Prescription </a></li>
                                    <li class="nav-item"><a class="nav-link"  href="#" @click.prevent="tab ='Past'" :class="(tab =='Past')?'active':''">Past Prescription </a></li>
                                </ul>
                                <ul class="d-flex justify-content-end test-interaction">
                                    <li class="nav-item">
                                        <router-link class="nav-link Test-button border-radius-8" to="/drug-interaction"><i class="icon icon-medicine"></i>Test drug interaction</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link class="nav-link gray-button border-radius-8" to="/prescription-main"><i class="icon icon-plus"></i>Add New Prescription</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link gray-btn icon-area border-radius-8" href="#"><i class="icon icon-download"></i></a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link gray-btn icon-area border-radius-8" href="#"><i class="icon icon-mail"></i></a>
                                    </li>
                                </ul>
                            </div>
                            
                            <div class="tab-content">
                                <current-prescription v-if="tab == 'Current'"></current-prescription>
                                <past-prescription v-else-if="tab == 'Past'"></past-prescription>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import currentprescription from './current-prescription'
    import pastprescription from './past-prescription'
    export default {
        name: "prescription-with-medicine",
        data() {
            return {
                tab  :'Current'
            };
        },
        components:{
            currentPrescription : currentprescription,
            pastPrescription : pastprescription
        },
        created(){
           this.pageName('Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-with-medicine.vue